import { paymentMethodModel, UserRole } from '~/models';
export const managePaymentMethodsTextsPath = 'components.managePaymentMethods';
export function isSelectablePaymentMethod(paymentMethod, isTerminatedAgreement, isSelected, isProposal, selectedPMRequiresVerification, isOnlyPaymentMethod) {
    return !isTerminatedAgreement && !isSelected && !(paymentMethodModel.isBankAccount(paymentMethod) && paymentMethodModel.isErroredBankAccount(paymentMethod.bankAccount)) && !paymentMethodModel.isFailedDueToDuplicate(paymentMethod) && (isOnlyPaymentMethod || isProposal || selectedPMRequiresVerification ? paymentMethodModel.requiresVerification(paymentMethod) || paymentMethodModel.isVerified(paymentMethod) : paymentMethodModel.isVerified(paymentMethod));
}
export async function fetchPaymentMethods(param) {
    let { isPreview, isSample, isProposal, vendorId, businessId, initialSelectedPaymentMethodId, getSelectedPaymentMethod, vendorGetPaymentMethod, clientGetPaymentMethod } = param;
    if (isPreview || isSample) {
        return {
            paymentMethods: []
        };
    }
    const isVendorInRelationship = businessId === vendorId;
    const fetchSelectedFundingSourceId = isProposal ? Promise.resolve(initialSelectedPaymentMethodId) : getSelectedPaymentMethod().then((selected)=>selected === null || selected === void 0 ? void 0 : selected.id);
    const [paymentMethods, selectedFundingSourceId] = await Promise.all([
        isVendorInRelationship ? vendorGetPaymentMethod() : clientGetPaymentMethod(),
        fetchSelectedFundingSourceId
    ]);
    return {
        paymentMethods,
        selectedFundingSourceId
    };
}
export function createPaymentSetupHandlers(param) {
    let { isVendor, paymentMethodHandlers, customerId, vendorId } = param;
    const createSetupIntent = ()=>isVendor ? paymentMethodHandlers.vendorCreateSetupIntent(customerId) : paymentMethodHandlers.clientCreateSetupIntent(vendorId);
    const addToBusiness = (paymentMethodId)=>isVendor ? paymentMethodHandlers.vendorAddToBusiness(paymentMethodId, customerId) : paymentMethodHandlers.clientAddToBusiness(paymentMethodId, vendorId);
    return {
        createSetupIntent,
        addToBusiness
    };
}
export function getRequiresPMActionConfirmation(isVendor, userRole, isProposal) {
    return (isVendor || userRole === UserRole.Accountant) && !isProposal;
}
export function doPaymentMethodAction(action, requiresPMActionConfirmation, openOnBehalfModal, paymentMethod) {
    if (requiresPMActionConfirmation) {
        openOnBehalfModal(action, paymentMethod);
    } else {
        action();
    }
}
export function shouldPromptConnectAfterAdding(addedPM) {
    return paymentMethodModel.isVerified(addedPM);
}
export function getRenderedMenuItem(param) {
    let { disconnectable, removable, isSelected, paymentMethodIsRemovable, onDisconnect, onRemove, texts, isAdHoc = false } = param;
    if (disconnectable) {
        return {
            type: 'disconnect',
            text: isAdHoc ? texts.disconnect() : texts.disconnectFromAgreement(),
            disabled: false,
            disabledTooltipText: '',
            skin: 'error',
            onClick: onDisconnect
        };
    } else if (removable) {
        return {
            type: 'remove',
            text: texts.remove(),
            disabled: false,
            disabledTooltipText: '',
            skin: 'error',
            onClick: onRemove
        };
    } else {
        return {
            type: 'disabled-remove',
            text: texts.remove(),
            skin: 'secondary',
            disabled: true,
            disabledTooltipText: isSelected ? texts.disabledRemoveTooltipInUse() : paymentMethodIsRemovable ? texts.disabledRemoveTooltipTemporary() : texts.disabledRemoveTooltipInAnotherAgreement()
        };
    }
}
